import { render, staticRenderFns } from "./UploadResultCard.vue?vue&type=template&id=74abe19d&scoped=true"
import script from "./UploadResultCard.vue?vue&type=script&lang=js"
export * from "./UploadResultCard.vue?vue&type=script&lang=js"
import style0 from "./UploadResultCard.vue?vue&type=style&index=0&id=74abe19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74abe19d",
  null
  
)

export default component.exports